var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRiteBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_61",
    "data-name": "Group 61",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 26.43,
    viewBox: "0 0 80 26.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M346.584-285.371c2.7-1.828,3.947-3.809,3.926-6.756a7.948,7.948,0,0,0-7.965-7.856h-8.27a.757.757,0,0,0-.755.755v24.919a.758.758,0,0,0,.755.755h3.775a.757.757,0,0,0,.755-.755v-9.439a.378.378,0,0,1,.377-.378h.982a.72.72,0,0,1,.68.491l3.851,9.326a1.081,1.081,0,0,0,1.095.755h2.742c.755,0,.717-.358.717-.684l-.028-2.929a1.358,1.358,0,0,0-.109-.52l-2.756-6.439C346.093-284.692,346.055-284.994,346.584-285.371Zm-4-4.04h-3.4a.357.357,0,0,1-.377-.378v-4.53a.357.357,0,0,1,.377-.378h3.4a2.676,2.676,0,0,1,2.643,2.643A2.65,2.65,0,0,1,342.582-289.411Z",
    transform: "translate(-333.52 299.983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M497.28-299.983H481.8a.757.757,0,0,0-.755.755v3.775a.757.757,0,0,0,.755.755h4.72a.357.357,0,0,1,.378.378v20.011a.757.757,0,0,0,.755.755h3.776a.757.757,0,0,0,.755-.755v-20.011a.357.357,0,0,1,.377-.378h4.719a.757.757,0,0,0,.756-.755v-3.775A.757.757,0,0,0,497.28-299.983Z",
    transform: "translate(-435.248 299.983)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M556.332-278.839h-8.948a.357.357,0,0,1-.377-.377v-4.531a.357.357,0,0,1,.377-.378h8.5a.757.757,0,0,0,.755-.755v-3.775a.758.758,0,0,0-.755-.756h-8.5a.356.356,0,0,1-.377-.378v-4.53a.357.357,0,0,1,.377-.378h8.8a.757.757,0,0,0,.755-.755v-3.775a.757.757,0,0,0-.755-.755H542.476a.757.757,0,0,0-.756.755v24.919a.757.757,0,0,0,.756.755h13.857a.757.757,0,0,0,.755-.755v-3.776A.758.758,0,0,0,556.332-278.839Z",
    transform: "translate(-477.087 299.983)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M462.678-299.983H458.9a.756.756,0,0,0-.619.322.753.753,0,0,0-.137.434v3.774a.752.752,0,0,0,.129.423.756.756,0,0,0,.627.333h3.774a.754.754,0,0,0,.535-.222.753.753,0,0,0,.221-.535v-3.774a.753.753,0,0,0-.183-.494A.754.754,0,0,0,462.678-299.983Z",
    transform: "translate(-419.459 299.983)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M410.424-282.955h-2.893a.758.758,0,0,0-.536.222L390.26-266a.758.758,0,0,0-.222.536v2.893a.758.758,0,0,0,.758.758h2.893a.759.759,0,0,0,.536-.222l16.735-16.736a.758.758,0,0,0,.222-.536V-282.2A.758.758,0,0,0,410.424-282.955Z",
    transform: "translate(-372.493 288.241)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRiteBlack);
export default __webpack_public_path__ + "static/media/logo_rite_black.d86a68875a98ed710ddca8077eb2fecc.svg";
export { ForwardRef as ReactComponent };